
<template>
  <div class="content">
    <div class="set_wrap">
      <el-form ref="form" :model="formdata">
        <el-form-item>
          是否设置满包邮？
          <el-radio-group v-model="formdata.package_set">
            <el-radio v-for="(item,index) in isfree" :label="item.value" :key="index">{{item.label}}</el-radio>
          </el-radio-group>  
        </el-form-item>
        <el-form-item v-if="formdata.package_set==1">
          <div>
            <el-col style="width: 24px;">满</el-col>
            <el-col :span="2"><el-input v-model="formdata.full_price"></el-input></el-col>
            <el-col :span="1">&nbsp;&nbsp;包邮</el-col>
          </div>
        </el-form-item>        
        <!-- <el-form-item>
          2、订单包含包邮商品，整单是否包邮？
          <el-radio-group v-model="formdata.whole_package">
            <el-radio v-for="(item,index) in isfree" :label="item.value" :key="index">{{item.label}}</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import api from "@/api.js";
import { isfree } from "@/util/util.js";
export default {
  name: "shippingSettings",
  data() {
    return {
      isfree: isfree,
      formdata: {
        package_set: "",
        whole_package: "",
        full_price: ""
      }
    };
  },
  created() {
    this.queryfreight();
  },
  methods: {
    // 查询包邮设置
    queryfreight() {
      let params = {};
      this.axios
        .post(api.freight_package_info, params)
        .then(response => {
          if (response.data.code == 0) {
            this.formdata.package_set = response.data.info.package_set;
            this.formdata.whole_package = response.data.info.whole_package;
            this.formdata.full_price = response.data.info.full_price;
          } else {
          }
        })
        .catch(() => {});
    },
    save() {
      this.submitsave();
    },
    submitsave() {
      let params = {
        package_set: this.formdata.package_set,
        whole_package: this.formdata.whole_package,
        full_price: this.formdata.full_price
      };
      this.axios
        .post(api.freight_package_set, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
          } else {
          }
        })
        .catch(() => {});
    }
  }
};
</script>